export default __webpack_public_path__ + "static/media/Facebook.8bf08dfc.svg";